import React from "react";
import PropTypes from "prop-types";
import { Modal, Avatar, Badge } from "../../../components/ui";
import BootstrapSpinner from "../../../sharedComponent/BootstrapSpinner";
import ApiConfig from "../../../api/ApiConfig";

const ViewsListModal = ({ show, onHide, viewCountList, loading }) => {
  const title = (
    <div className="ann-views__title">
      <span>Views</span>
      <Badge variant="info">{viewCountList.length}+</Badge>
    </div>
  );

  return (
    <Modal show={show} onHide={onHide} size="lg" title={title}>
      {loading ? (
        <div className="ann-modal-loader">
          <BootstrapSpinner />
        </div>
      ) : viewCountList && viewCountList.length > 0 ? (
        <div className="ann-views">
          {viewCountList.map((count, index) => {
            const imgSrc = count.photoPath
              ? ApiConfig.BASE_URL_FOR_IMAGES + count.photoPath
              : "";
            return (
              <div className="ann-views__row" key={"caufods" + index}>
                <div className="ann-views__person">
                  <Avatar src={imgSrc} name={count.name} size="md" />
                  <span className="ann-views__name">{count.name}</span>
                </div>
                <span className="ann-views__role">{count.DesignationName}</span>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="ann-modal-empty">Data Not Found</div>
      )}
    </Modal>
  );
};

ViewsListModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  viewCountList: PropTypes.array,
  loading: PropTypes.bool,
};

ViewsListModal.defaultProps = {
  viewCountList: [],
  loading: false,
};

export default ViewsListModal;
